import { render, staticRenderFns } from "./NotificationTemplateChannel.vue?vue&type=template&id=3375d070&"
import script from "./NotificationTemplateChannel.vue?vue&type=script&lang=ts&"
export * from "./NotificationTemplateChannel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports